export enum ShotBlockedAttribute {
  InsidePenaltyArea = 440,
  OutsidePenaltyArea = 441,
  LeftFoot = 442,
  RightFoot = 443,
  Head = 444,
  Volley = 853,
  BicycleKick = 854,
  Chip = 855,
  BigChanceMissed = 890,
  FreeKick = 892,
  Normal = 931,
  FirstTouch = 932,
  NoPressure = 933,
  LightPressure = 934,
  HighPressure = 935,
  ClearPosition = 936,
  OneDefender = 937,
  TwoOrMoreDefenders = 938,
  UncomfortablePosition = 939,
  EmptyNet = 940,
  OtherBodyPart = 941,
  BlockedByTeammate = 3042,
}
